<template>
    <div>
        <table style="margin-left: 45px;">
            <tr>
                <td>
                    <i class="icon iconfont icon-square"
                       style="font-size: 30px; color: #409EFF; margin-right: 0"></i>
                </td>
                <td>
                    <span @click="changeMode('task')" :class="{active: mode === 'task', 'btn-task': true}">设置计划时间</span>
                </td>
                <td>
                    <i class="el-icon-star-off" style="font-size: 28px;"></i>
                </td>
                <td>
                    <span @click="changeMode('milestone')"
                          :class="{active: mode === 'milestone', 'btn-milestone': true}">设置里程碑</span>
                </td>
                <td style="width: 20px;"></td>
                <td>
                    计划日期：
                </td>
                <td style="font-size: 15px;">
                    {{range.start}} —— {{range.end}}
                    <i class="el-icon-edit-outline" @click="editPlanTime"
                       style="color: #00C1C9; margin-right: 0;font-size: 18px;cursor: pointer;"></i>
                </td>
            </tr>
        </table>
        <div class="table-content" ref="table" :style="{height:(screenHeight - 140) + 'px'}">
            <div class="planOpt" ref="planOpt" style="overflow:hidden;margin-top:64px;">
                <table class="plan-opt">
                    <tr>
                        <td style="height:0;"></td>
                        <td style="height:0;"></td>
                    </tr>
                    <tr>
                        <td style="height:0;"></td>
                        <td style="height:0;"></td>
                    </tr>
                    <tr v-for="(task, index) in tasks" :key="task.uuid">
                        <td class="height32">
                            <i class="el-icon-circle-plus-outline" @click="addTask(index + 1)"></i>
                        </td>
                        <td class="height32">
                            <i class="el-icon-remove-outline" @click="deleteTask(index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <div class = "left-content">
                <div class = "table-head">
                    <table class= "full-table">
                        <thead>
                        <tr>
                            <th rowspan="2" class="plan-title" style="width: 180px;height:65px;line-height: 65px;border-right:none;">
                                <span style="color: red;">*</span>项目阶段
                            </th>
                            <th rowspan="2" class="plan-title" style="width: 180px;height:65px;line-height: 65px;border-right:none;">
                                <span style="color: red;">*</span>项目任务
                            </th>
                        </tr>
                        </thead>
                    </table>
                </div>
                <div class="table-left">
                    <div class = "table"
                         ref="firstColLayer"
                         data-_ref="firstColLayer"
                    >
                        <table class= "full-table">
                            <tbody>
                            <tr v-for="task in tasks" :key="'task' + task.uuid">
                                <td class="height32" style="width: 180px;text-align: center;height:32px;">
                                    <input v-model="task.stage" :class="{
                                stage: task.stage || !isSaving || (!(task.content || task.stage || task.weeks.length>0)),
                                stageEmpty: (!task.stage) && (task.content || task.weeks.length>0) && isSaving}"/>
                                </td>
                                <td class="height32" style="width: 180px;text-align: center;height:32px;">
                                    <input v-model="task.content" :class="{
                                taskContent: task.content || !isSaving || (!(task.content || task.stage || task.weeks.length>0)),
                                contentEmpty: (!task.content) && (task.stage || task.weeks.length>0) && isSaving}"/>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class = "right-content" ref="right" style="min-width:200px;">
                <div class = "table-head"
                     ref="firstRowLayer"
                     data-_ref="firstRowLayer">
                    <table class= "full-table">
                        <thead>
                        <tr>
                            <td v-for="month in months" v-bind:key="'month.month' + month.month" :colspan="month.weeks"
                                style="text-align: center;" class="height32">
                                {{ month.month.substr(0, 4) + '年' + parseInt(month.month.substr(4, 2)) + '月' }}
                            </td>
                        </tr>
                        <tr>
                            <template v-for="month in months">
                                <td v-for="weekIndex in month.weeks" :key="'weekIndex' + month.month + weekIndex"
                                    style="text-align: center;" class="height32 width32">
                                    {{weekIndex}}
                                </td>
                            </template>
                        </tr>
                        </thead>
                    </table>
                </div>
                <div class="table"
                     style="overflow-y:auto;overflow-x: scroll;"
                     ref="tableContainer"
                     @scroll="tableDivScroll($event)"
                >
                    <table class="content-table" ref="contTable">
                        <tbody ref="tbody">
                        <tr v-for="task in tasks" :key="'task' + task.uuid">
                            <td v-for="week in weeks" v-bind:key="'week' + week"
                                @click="toggle(task, week)" class="pointer"
                                style="text-align: center;"
                                :class="{
                                    task: task.weeks.indexOf(week) > -1,
                                    milestone: hasMilestone(task.uuid, week),
                                    taskWeek: (task.weeks.length>0 || !isSaving) && task.weeks.indexOf(week) === -1,
                                    taskWeekEmpty: task.weeks.length===0 && (task.stage || task.content) && isSaving,
                                    width32: true, height32: true
                                }">
                                <template v-if="hasMilestone(task.uuid, week)">
                                    <el-dropdown trigger="click" @command="handleCommand">
                                        <span class="el-dropdown-link" v-on:click.stop>
                                            <i class="el-icon-star-off" style="font-size: 26px;"></i>
                                            <span style="position: absolute; left: 28px; top: 6px; width: auto;white-space:nowrap;">
                                                {{milestones.filter(ms => ms.week === week && ms.taskId === task.uuid)[0].title}}
                                            </span>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="{
                                                task: task,
                                                week: week,
                                                milestone: getMilestone(task.uuid, week),
                                                type: 'edit'
                                            }" style="width: 68px;height: 36px;">编辑</el-dropdown-item>
                                            <el-dropdown-item :command="{
                                                milestone: getMilestone(task.uuid, week),
                                                type: 'delete'
                                            }">删除</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <el-button class="planBtn" type="primary" v-on:click="savePlan">保存</el-button>
        <el-button class="saveTemBtn" v-on:click="importTemplate">导入模板</el-button>
        <el-dialog title="选择里程碑" :visible.sync="dialogVisible" width="30%">
            <el-form label-position="right" label-width="100px" :model="milestoneSelector">
                <el-form-item label="里程碑名称">
                    <el-select v-model="milestoneSelector.uuid" placeholder="请选择" style="width: 100%;"
                               @change="handleChange">
                        <el-option :key="'milestone-option-' + option.uuid" v-for="option in remainingMilestoneOptions"
                                   :label="option.title" :value="option.uuid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="说明">
                    <el-input type="textarea" readonly v-model="milestoneSelector.desc" :rows="3"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="handleCancelChoice">取 消</el-button>
            <el-button type="primary" @click="handleClose">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="引入模板" :visible.sync="templateVisible" width="30%">
            <el-form label-position="right" label-width="100px" :model="templateSelector">
                <el-form-item label="模板名称" :required="templateVisible">
                    <el-select v-model="templateSelector.uuid" placeholder="请选择" style="width: 100%;"
                               @change="templateChange">
                        <el-option :key="'template-option-' + option.uuid" v-for="option in templateOptions"
                                   :label="option.name" :value="option.uuid"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="说明">
                    <el-input type="textarea" readonly v-model="templateSelector.remark" :rows="3"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="templateVisible=false">取 消</el-button>
            <el-button type="primary" @click="templateConfirm">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="选择日期" :visible.sync="dateVisible" width="30%">
            <el-form label-position="right" label-width="100px" :model="templateSelector">
                <el-form-item label="开始日期" :required="dateVisible">
                    <el-date-picker v-model="startDate" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期" :required="dateVisible">
                    <el-date-picker v-model="endDate" type="date" placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
            <el-button @click="dateVisible=false">取 消</el-button>
            <el-button type="primary" @click="dateConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {plan} from "../../../mixins/plan";
    import '../../../assets/plan.css';
    import planTaskService from "../../../service/planTaskService";

    export default {
        mixins: [plan],
        data: function () {
            return {
                screenHeight: window.innerHeight,
                range: {
                    start: '',
                    end: ''
                },
                tasks: [
                    {
                        stage: '',
                        content: '',
                        weeks: [],
                        uuid: 1
                    },
                    {
                        stage: '',
                        content: '',
                        weeks: [],
                        uuid: 2
                    },
                    {
                        stage: '',
                        content: '',
                        weeks: [],
                        uuid: 3
                    },
                    {
                        stage: '',
                        content: '',
                        weeks: [],
                        uuid: 4
                    }
                ],
                mode: 'task',
                milestones: [
                ],
                milestoneOptions: [],
                templateOptions: [],
                milestoneSelector: {
                    uuid: null,
                    title: null,
                    desc: null
                },
                templateSelector: {
                    uuid: null,
                    name: null,
                    remark: null
                },
                dialogVisible: false,
                templateVisible: false,
                dateVisible: false,
                isSaving: false,
                editingMilestoneId: "",
                startDate: "",
                endDate: "",
                indexUuid: 5
            }
        },
        created: async function(){
            let resp = await planTaskService.getMileStoneList();
            if(resp.data.Status==="1"){
                this.milestoneOptions = resp.data.Data;
            }
            let result = await planTaskService.getAvailableTemplate();
            if(result.data.Status==="1"){
                this.templateOptions = result.data.Data;
            }

            let res = await planTaskService.getTaskList(this.$route.query.projectId);
            if(res.data.Status==="1"){
                if(res.data.Data.tasks.length>0){
                    this.tasks = res.data.Data.tasks;
                    this.milestones = res.data.Data.milestones;
                }
                this.range.start = res.data.Data.startTime;
                this.range.end = res.data.Data.endTime;
                res.data.Data.startTime =res.data.Data.startTime.replace(/-/g, "/");
                res.data.Data.endTime =res.data.Data.endTime.replace(/-/g, "/");
                this.startDate = new Date(res.data.Data.startTime+" 00:00:00").toISOString();
                this.endDate = new Date(res.data.Data.endTime+" 00:00:00").toISOString();
            }
        },
        watch: {},
        mounted:function () {
            document.body.style.overflow='auto';
            this.$refs.right.style.maxWidth= "" + this.$refs.table.offsetWidth - 440 + "px";//减390是减去左侧div宽度
            this.$refs.firstRowLayer.style.maxWidth= "" + this.$refs.table.offsetWidth - 457 + "px";
            this.$refs.tableContainer.style.height= "" + this.$refs.table.offsetHeight - 64 + "px"; //减去th高度和滚动条高度
            this.$refs.firstColLayer.style.height= "" + this.$refs.table.offsetHeight - 81 + "px";
            this.$refs.planOpt.style.height= "" + this.$refs.table.offsetHeight - 81 + "px";
        },
        methods: {
            tableDivScroll () {
                const $target = this.$refs.tableContainer;
                // 行固定
                this.$refs.firstRowLayer.scrollLeft = $target.scrollLeft;
                // 列固定
                this.$refs.firstColLayer.scrollTop = $target.scrollTop;
                this.$refs.planOpt.scrollTop = $target.scrollTop;
            },
            addTask(index) {
                this.tasks.splice(index, 0, {
                    weeks: [],
                    uuid: this.indexUuid
                });
                this.indexUuid +=1;
            },
            deleteTask(index) {
                if(this.tasks.length===1){
                    this.$message({
                        type: 'success',
                        message: '已经是最后一行了，无法删除!'
                    });
                }else{
                    var toDeleteMileStone = this.milestones.filter(ms => ms.taskId===this.tasks[index].uuid);
                    if(toDeleteMileStone.length>0){
                        var toDeleteIndex = this.milestones.indexOf(toDeleteMileStone[0]);
                        this.milestones.splice(toDeleteIndex,1);
                    }
                    this.tasks.splice(index, 1);
                }
            },
            async toggle(task, week) {
                if (this.mode === 'task') {
                    let index = task.weeks.indexOf(week);
                    if (index > -1) {
                        let res = await planTaskService.getReportInfo(week, this.$route.query.projectId);
                        if(res.data.Status==="1"){
                            if(res.data.Data){
                                this.$confirm('修改计划时间后，原计划时间内已上传的周月报文件将自动删除，确定修改吗？', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消'
                                }).then(() => {
                                    task.weeks.splice(index, 1);
                                });
                            }else{
                                task.weeks.splice(index, 1);
                            }
                        }
                    } else {
                        task.weeks.push(week);
                    }
                } else {
					if(task.weeks.indexOf(week) > -1) {
						this.$message({
						    message: "里程碑不能与计划时间重叠",
						    type: 'error',
						    duration: 1500
						});
						return;
					}
                    // 如果代码执行到这里，说明点击的空白单元格，需弹出选择里程碑面板
                    this.milestoneSelector.uuid = null;
                    this.milestoneSelector.desc = null;
                    this.milestoneSelector.taskId = task.uuid;
                    this.milestoneSelector.week = week;
                    this.dialogVisible = true;
                }
            },
            handleCommand(cmd) {
                if(cmd.milestone.status==="complete"){
                    this.$message({
                        message: "该里程碑已完成，无法编辑或删除!",
                        type: 'error',
                        duration: 1500
                    });
                    return;
                }
                if (cmd.type === 'delete') {
                    let ms = this.milestones.filter(ms => ms.milestoneId === cmd.milestone.milestoneId);
                    this.$confirm('确定删除里程碑-'+ms[0].title+'吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        // 同一个单元格上只能有一个里程碑，所以下面用 ms[0] 也是没有问题的
                        if (ms.length > 0) {
                            let index = this.milestones.indexOf(ms[0]);
                            this.milestones.splice(index, 1);
                        }
                        this.$message({
                            type: 'success',
                            message: '已删除，保存后起效!'
                        });
                    });
                } else if (cmd.type === 'edit') {
                    // 弹出选择里程碑面板
                    this.milestoneSelector.uuid = cmd.milestone.milestoneId;
                    this.milestoneSelector.desc = cmd.milestone.desc;
                    this.milestoneSelector.title = cmd.milestone.title;
                    this.milestoneSelector.taskId = cmd.task.uuid;
                    this.milestoneSelector.week = cmd.week;
                    this.editingMilestoneId = cmd.milestone.milestoneId;
                    this.dialogVisible = true;
                }
            },
            handleClose() {
                let ms = this.milestones.filter(ms => ms.taskId === this.milestoneSelector.taskId
                    && ms.week === this.milestoneSelector.week);
                // 同一个单元格上只能有一个里程碑，所以下面用 ms[0] 也是没有问题的
                if (ms.length > 0) {
                    let index = this.milestones.indexOf(ms[0]);
                    this.milestones.splice(index, 1);
                }
                this.milestones.push({
                    taskId: this.milestoneSelector.taskId,
                    week: this.milestoneSelector.week,
                    title: this.milestoneSelector.title,
                    milestoneId: this.milestoneSelector.uuid,
                    desc: this.milestoneSelector.desc
                });
                this.dialogVisible = false;
                this.editingMilestoneId = "";
            },
            handleCancelChoice(){
                this.dialogVisible = false;
                this.editingMilestoneId = "";
            },
            templateChange() {
                let selected = this.templateOptions.filter(ms => ms.uuid === this.templateSelector.uuid)[0];
                this.templateSelector.remark = selected.remark;
                this.templateSelector.name = selected.name;
            },
            handleChange(){
                let selected = this.milestoneOptions.filter(ms => ms.uuid === this.milestoneSelector.uuid)[0];
                this.milestoneSelector.desc = selected.desc;
                this.milestoneSelector.title = selected.title;
            },
            async savePlan(){
                var stageEmpty = this.tasks.filter(t=>!(t.stage) && (t.content || t.weeks.length>0));
                var contentEmpty = this.tasks.filter(t=>!(t.content) && (t.stage || t.weeks.length>0));
                var weekEmpty = this.tasks.filter(t=>t.weeks.length===0 && (t.content || t.stage));
                var tips="";
                if(stageEmpty.length>0){
                    tips += "有项目阶段未填写！";
                }
                if(contentEmpty.length>0){
                    tips += "有项目任务未填写！";
                }
                if(weekEmpty.length>0){
                    tips += "有项目日期未设置！";
                }
                if(tips.length>0){
                    this.isSaving=true;
                    this.$message({
                        message: tips,
                        type: 'error',
                        duration: 1500
                    });
                    return;
                }
                if(this.milestones.length===0){
                    this.isSaving=true;
                    this.$message({
                        message: "请至少设置一个里程碑!",
                        type: 'error',
                        duration: 1500
                    });
                    return;
                }
                this.tasks.forEach(t=>{
                    t.taskMilestones = this.milestones.filter(m => m.taskId === t.uuid);
                });
                let resp = await planTaskService.savePlanTasks(this.$route.query.projectId, this.tasks);
                if(resp.data.Status==="1"){
                    this.$message({
                        message: "保存成功!",
                        type: 'success',
                        duration: 800
                    });
                    window.setTimeout(() => {
                        this.$router.push({
                            path: 'View',
                            query: {
                                projectId: this.$route.query.projectId,
                                isEditable: this.$route.query.isEditable
                            }
                        });
                    }, 1000)
                }
            },
            importTemplate(){
                if(this.templateOptions.length===0){
                    this.$message({
                        message: "您尚未设置模板，无法引入！",
                        type: "error",
                        duration: 1500
                    });
                    return;
                }
                this.templateVisible = true;
            },
            async templateConfirm(){
                if(this.templateSelector.uuid===null){
                    this.$message({
                        message: "请选择模板！",
                        type: "error"
                    });
                    return;
                }
                let resp = await planTaskService.importTemplate(this.templateSelector.uuid);
                if(resp.data.Status==="1"){
                    this.templateVisible = false;
                    var indexArr=[];
                    for(var i=this.tasks.length-1; i>=0; i--){
                        var task=this.tasks[i];
                        if((task.stage===undefined || task.stage==="") && (task.content===undefined || task.content==="")){
                            indexArr.push(i);
                        }else{
                            break;
                        }
                    }
                    if(indexArr.length>0){
                        for(var j=0; j<indexArr.length; j++){
                            var index = indexArr[j];
                            this.tasks.splice(index, 1);
                        }
                    }
                    this.tasks = this.tasks.concat(resp.data.Data);
                }
            },
            editPlanTime(){
                this.dateVisible=true;
            },
            async dateConfirm(){
                this.range.start=this.$moment(this.startDate).format("YYYY-MM-DD");
                this.range.end=this.$moment(this.endDate).format("YYYY-MM-DD");
                let resp = await planTaskService.updatePlanDate(this.weeks, this.$route.query.projectId, this.$moment(this.startDate).format("YYYY-MM-DD"), this.$moment(this.endDate).format("YYYY-MM-DD"));
                if(resp.data.Status==="1"){
                    if(resp.data.Data.startTime.length>0){
                        this.range.start=resp.data.Data.startTime;
                        this.range.end=resp.data.Data.endTime;
                        this.startDate = new Date(resp.data.Data.startTime+" 00:00:00").toISOString();
                        this.endDate = new Date(resp.data.Data.endTime+" 00:00:00").toISOString();
                        this.$message({
                            message: "存在计划日期范围外的时间计划或里程碑，无法修改!",
                            type: "error"
                        });
                        this.dateVisible=false;
                    }else{
                        this.$message({
                            message: "计划日期修改成功!",
                            type: "success",
                            duration: 1500
                        });
                        this.dateVisible=false;
                    }
                }
            }
        },
        computed: {
            remainingMilestoneOptions() {
                return this.milestoneOptions.filter(ms => {
                    return this.milestones.every(ms2 => ms2.milestoneId !== ms.uuid) || ms.uuid === this.milestoneSelector.uuid || ms.uuid===this.editingMilestoneId;
                })
            }
        }
    }
</script>
<style scoped>
    .plan-opt td {
        font-size: 20px;
        color: #409EFF;
    }

    .milestone .el-icon-star-on {
        color: #F56C6C;
    }

    .btn-task {
        border: 1px solid #409EFF;
        color: #409EFF;
        padding: 3px 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    .btn-task.active {
        color: white;
        background: #409EFF;
    }

    .btn-milestone {
        border: 1px solid #CCCCCC;
        color: black;
        padding: 3px 10px;
        border-radius: 5px;
        cursor: pointer;
    }

    .btn-milestone.active {
        color: white;
        background: #CCCCCC;
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: auto !important;
    }
    .wrapperTable>tr>td{
        vertical-align: top;
        overflow: hidden;
    }
    .table-content {
        overflow-y: hidden;
    }
    .planOpt {
        float:left;
    }
    .left-content{
        width:360px;
        float:left;
        display: inline-block;
    }
    .right-content{
        float:left;
        display: inline-block;
    }
    .table-head{
        width:100%;
        overflow:hidden;
    }
    .left-content .table-body{
        overflow:hidden;
    }
    .table-left .table{
        background-color:#FFFFFF;
        overflow:hidden;
        margin-right:0;
        padding-right:0;
    }
    /*.table::-webkit-scrollbar{display:none}*/
    .content-table td, .full-table td {
        text-align: center;
        word-wrap: break-word;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
    }
    .table-content th{
        height:32px;
        display: inline-block;
        /*line-height:14px;*/
        padding:auto 0;
        margin:auto 0;
        vertical-align: middle;
    }
    .left-content th,.left-content td,.right-content td {
        border: 1px double #dcdfe6;
    }
    thead,tbody{
    }
    .content-table tr:first-child td,.table-left tr:first-child td {
        border-top: none;
    }
    .table-left tr td:last-child {
        border-right:none;
    }
    </style>